import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalificacionGrupoComponent } from './formulario/formulario.component';
import { CalificacionReprobadosComponent } from './reprobados/reprobados.component';
import { MonitorReprobadosComponent } from './monitor-reprobados/monitor-reprobados.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'control-escolar/calificacion-grupo',
    children: [
       { path: 'nuevo', component: CalificacionGrupoComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'control-escolar/calificacion-reprobado',
    children: [
      { path: 'nuevo', component: CalificacionReprobadosComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'control-escolar/monitor-reprobados',
    children: [
      { path: 'monitor', component: MonitorReprobadosComponent }
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CalificacionGrupoRoutingModule { }

